import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, Clock } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking", data: null });

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", data: null }); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState({ status: "paid", data }); return; }
        if (["failed", "expired", "canceled"].includes(data.payment_status)) { setState({ status: "failed", data }); return; }
        if (tries >= 12) { setState({ status: "pending", data }); return; }
        timer = setTimeout(poll, 2000);
      } catch {
        if (tries >= 12) { setState({ status: "error", data: null }); return; }
        timer = setTimeout(poll, 2000);
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  const wrap = "flex min-h-screen items-center justify-center bg-sfc-night px-5";
  const card = "w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.03] p-10 text-center";

  if (state.status === "checking") {
    return <div className={wrap}><div className={card} data-testid="payment-checking"><Loader2 className="mx-auto animate-spin text-sfc-orange" size={44} /><p className="mt-5 text-white/70">Betaling wordt geverifieerd...</p></div></div>;
  }
  if (state.status === "paid") {
    return <div className={wrap}><div className={card} data-testid="payment-success"><CheckCircle2 className="mx-auto text-emerald-400" size={54} /><h1 className="mt-5 font-display text-3xl text-white">Betaling geslaagd!</h1><p className="mt-3 text-white/70">Order <span className="font-semibold text-sfc-orange">{state.data?.order_number}</span> is definitief bevestigd. U ontvangt de orderbevestiging en factuur per e-mail en WhatsApp.</p><Link to="/" className="mt-8 inline-block rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-7 py-3 text-sm font-semibold text-white">Terug naar home</Link></div></div>;
  }
  if (state.status === "pending") {
    return <div className={wrap}><div className={card} data-testid="payment-pending"><Clock className="mx-auto text-sfc-yellow" size={54} /><h1 className="mt-5 font-display text-2xl text-white">Betaling in verwerking</h1><p className="mt-3 text-white/70">Uw betaling wordt nog verwerkt. U ontvangt automatisch een bevestiging zodra deze definitief is.</p><Link to="/" className="mt-8 inline-block rounded-full border border-white/20 px-7 py-3 text-sm font-semibold text-white">Terug naar home</Link></div></div>;
  }
  return <div className={wrap}><div className={card} data-testid="payment-failed"><XCircle className="mx-auto text-red-400" size={54} /><h1 className="mt-5 font-display text-2xl text-white">Betaling niet voltooid</h1><p className="mt-3 text-white/70">Er is iets misgegaan met de betaling. Neem contact op of probeer het opnieuw.</p><Link to="/" className="mt-8 inline-block rounded-full border border-white/20 px-7 py-3 text-sm font-semibold text-white">Terug naar home</Link></div></div>;
}
